module.exports = __webpack_public_path__ + "static/media/mp3.3694b990.png";